import React from 'react';
function Lock({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M18.222 11H5.778C4.796 11 4 11.814 4 12.818v6.364C4 20.186 4.796 21 5.778 21h12.444c.982 0 1.778-.814 1.778-1.818v-6.364C20 11.814 19.204 11 18.222 11zM8 11V7.444c0-1.178.421-2.309 1.172-3.142C9.922 3.468 10.939 3 12 3c1.06 0 2.078.468 2.828 1.302.75.833 1.172 1.964 1.172 3.142V11"
      />
    </svg>
  );
}

export default Lock;
